__turbopack_context__.v({
  "applyModal": "mR0SjW_applyModal",
  "ctaRow": "mR0SjW_ctaRow",
  "memCta": "mR0SjW_memCta",
  "memCtaPrimary": "mR0SjW_memCtaPrimary",
  "memCtaSecondary": "mR0SjW_memCtaSecondary",
  "root": "mR0SjW_root",
  "typeformContainer": "mR0SjW_typeformContainer",
});
